import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import MyDialog from '@/components/MyDialog.vue';
import BooleanSelect from '@/components/BooleanSelect.vue';
import ConfirmDelete from '@/components/ConfirmDelete.vue';
import CharacterMenu from '../CharacterMenu.vue';
const authenticationModule = namespace('authentication');
let CharacterBuilderSettings = class CharacterBuilderSettings extends Vue {
    constructor() {
        super(...arguments);
        this.isOpen = false;
    }
    handleChangeMethod(newMethod) {
        this.$emit('updateCharacter', {
            baseAbilityScores: {
                Strength: 0,
                Dexterity: 0,
                Constitution: 0,
                Intelligence: 0,
                Wisdom: 0,
                Charisma: 0
            },
            settings: { abilityScoreMethod: newMethod }
        });
    }
};
__decorate([
    Prop(Object)
], CharacterBuilderSettings.prototype, "rawCharacter", void 0);
__decorate([
    Prop(Object)
], CharacterBuilderSettings.prototype, "completeCharacter", void 0);
__decorate([
    Prop(Object)
], CharacterBuilderSettings.prototype, "characterValidation", void 0);
__decorate([
    Prop(Boolean)
], CharacterBuilderSettings.prototype, "isDirty", void 0);
__decorate([
    authenticationModule.Getter
], CharacterBuilderSettings.prototype, "isLoggedIn", void 0);
CharacterBuilderSettings = __decorate([
    Component({
        components: {
            MyDialog,
            ConfirmDelete,
            CharacterMenu,
            BooleanSelect
        }
    })
], CharacterBuilderSettings);
export default CharacterBuilderSettings;
